export const environment = {
  production: true,
  connection: {
    name: 'LH Gleinstätten Softline',
    host: 'https://softline.gleinstaetten.rlh.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
